const api = {
  baseUrl: `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb`,
  horsesByFarm: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/horses.php?farm=${encodeURIComponent(
      farm
    )}`,
  horsesTempsByFarm: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/temperatures.php?farm=${encodeURIComponent(farm)}&task=list`,
  horseProfile: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/horseProfile.php?microchip=${microchip}&farm=${encodeURIComponent(farm)}`,
  updateHorse: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/horseProfile.php?microchip=${microchip}&farm=${encodeURIComponent(farm)}`,

  horseSchedule: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/horseSchedule.php?microchip=${microchip}&farm=${encodeURIComponent(farm)}`,
  horseUpcomingShows: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/shows.php?microchip=${microchip}&task=upcomingShows&farm=${encodeURIComponent(
      farm
    )}`,

  uploadDocument: (microchip: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/documents.php?microchip=${microchip}`,
  uploadPhoto: (microchip: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/horsePicture.php?microchip=${microchip}`,
  uploadUserPhoto: (userId: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/userPicture.php?id=${userId}`,
  horsePhoto: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/horsePicture.php?task=GetPhoto&microchip=${microchip}&farm=${encodeURIComponent(
      farm
    )}`,
  userPhoto: (userId: string, farm: string, update: number) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/userPicture.php?task=GetPhoto&userId=${userId}&farm=${encodeURIComponent(
      farm
    )}&count=${update}`,
  showPhoto: (showId: string, seed: number) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/showPicture.php?task=GetPhoto&showId=${showId}&seed=${seed}`,
  uploadTemperatures: (microchip: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/temperatures.php?microchip=${microchip}&farm=${encodeURIComponent(
      farm
    )}&task=upload`,

  account: () => `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/farm.php?task=createAccount`,
  userInfo: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/userInfo.php?task=userInfo&farm=${encodeURIComponent(farm)}`,
  userFromToken: (token: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/userInfo.php?task=userForToken&token=${token}&farm=`,
  changePassword: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/userInfo.php?task=changePassword&farm=${encodeURIComponent(farm)}`,

  showsByFarm: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/shows.php?farm=${encodeURIComponent(
      farm
    )}&task=showsEntered`,

  showsAvailable: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/shows.php?farm=${encodeURIComponent(
      farm
    )}&task=showsAvailable`,
  getShows: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/shows.php?farm=${encodeURIComponent(
      farm
    )}&task=getShows`,
  eventPassData: (eventId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/eventPasses.php?eventId=${eventId}&showId=&task=eventPass&farm=${encodeURIComponent(
      farm
    )}`,
  eventPassDataByShow: (showId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/eventPasses.php?showId=${showId}&showId=&task=eventPassDataByShow&farm=${encodeURIComponent(
      farm
    )}`,

  healthDeclarationRequirement: (eventId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/eventPasses.php?eventId=${eventId}&showId=&task=healthDeclarationRequirement&farm=${encodeURIComponent(
      farm
    )}`,
  eventPassesByFarm: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/eventPasses.php?showId=&task=list&farm=${encodeURIComponent(farm)}`,
  updateEventPass: (farm: string, id: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/eventPasses.php?farm=${encodeURIComponent(
      farm
    )}&showId=${id}`,
  submitEventPass: (eventId: string, farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/eventPasses.php?farm=${encodeURIComponent(
      farm
    )}&showId=&eventId=${eventId}`,

  createCheckoutSession: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/stripeCheckout.php?farm=${encodeURIComponent(farm)}`,
  showData: (showId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/shows.php?showId=${showId}&task=showData&farm=${encodeURIComponent(farm)}`,
  showsList: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/shows.php?farm=${encodeURIComponent(
      farm
    )}&task=showList`,
  updateShow: (showId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/shows.php?showId=${showId}&task=updateShow&farm=${encodeURIComponent(farm)}`,
  updateShowTwo: (showId: string, farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/equitraceWeb/shows.php?showId=${showId}&task=updateShow2&farm=${encodeURIComponent(farm)}`,
  removeShowPhoto: (showId: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/showPicture.php?task=RemoveShowPhoto&showId=${showId}`,
  uploadShowPhoto: (showId: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/showPicture.php?showId=${showId}`,

  // Horse Temperatures endpoints
  horseTemperatures: (filters?: string, sort?: string, page?: string, perPage?: string) => {
    const params = new URLSearchParams();
    if (filters) params.append("filter", filters);
    if (sort) params.append("sort", sort);
    if (page) params.append("page", page);
    if (perPage) params.append("perPage", perPage);
    const queryString = params.toString();
    return `/proxy/${process.env.REACT_APP_API_URL}/rest/horse-temperatures/index.php?${queryString}`;
  },

  horseTemperature: (microchip: string, entryTS: number) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/rest/horse-temperatures/index.php?microchip=${encodeURIComponent(
      microchip
    )}&entryTS=${entryTS}`,

  createHorseTemperature: () =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/horse-temperatures/index.php`,

  updateHorseTemperature: (microchip: string, entryTS: number) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/rest/horse-temperatures/index.php?microchip=${encodeURIComponent(
      microchip
    )}&entryTS=${entryTS}`,

  deleteHorseTemperature: (microchip: string, entryTS: number) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/rest/horse-temperatures/index.php?microchip=${encodeURIComponent(
      microchip
    )}&entryTS=${entryTS}`,

  // Horse Change Requests endpoints
  horseChangeRequests: (farm: string) =>
    `/proxy/${
      process.env.REACT_APP_API_URL
    }/rest/horse-change-requests/index.php?farm=${encodeURIComponent(farm)}`,

  usefSearch: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/usef-search/index.php?farm=${encodeURIComponent(
      farm
    )}`,

  horseChangeRequestsUpload: (microchip: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/horse-change-requests/upload-file/index.php?microchip=${microchip}`,
  updateEventPassHorse: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/eventPasses.php?farm=${encodeURIComponent(
      farm
    )}&task=updateEventPassHorse`,
  deleteEventPassHorse: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/eventPasses.php?farm=${encodeURIComponent(
      farm
    )}&task=deleteEventPassHorse`,
  getEstimatedEventPassByShowIdAndHorses: () =>
    `/proxy/${process.env.REACT_APP_API_URL}/equitraceWeb/eventPasses.php?task=getEstimatedEventPassByShowIdAndHorses`,
  horsesRestEndpoint: () => `/proxy/${process.env.REACT_APP_API_URL}/rest/horses/index.php`,
  mergeHorsesRestEndpoint: () =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/horses/merge/index.php`,
  farmUsersList: (farm: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/?farm=${encodeURIComponent(farm)}`,
  farmUsersInvite: () => `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/index.php`,
  farmUsersUpdate: (userId: string) =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/index.php`,
  farmUsersDelete: () => `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/index.php`,
  farmUsersResetPassword: () =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/reset/index.php`,
  farmUsersDeclineInvitation: () =>
    `/proxy/${process.env.REACT_APP_API_URL}/rest/farm-users/decline-invitation/index.php`,
  baseAPIUrl: `/proxy/${process.env.REACT_APP_API_URL}`,
};

const endpointMaker = {
  api,
};

export default endpointMaker;
